import React from "react";
import { defaultMusicContext, IMusicInterface } from "./MusicInterface";

export const MusicContext = React.createContext<IMusicInterface>(
  defaultMusicContext
);
export const MusicProvider = MusicContext.Provider;
export const MusicConsumer = MusicContext.Consumer;
